import { Component } from "@angular/core";
import { ApiRequestDto, ReportsService } from "../../api";
import { FacilitiesService } from "../../core";
import { DownloadFileContentModal } from "../download-file-content/download-file-content-modal.component";

@Component({
    selector: 'my-resident-allergy-modal',
    styleUrls: ['../download-file-content/download-file-content-modal.component.scss'],
    templateUrl: '../download-file-content/download-file-content-modal.component.html'
})
export class ResidentAllergyModal extends DownloadFileContentModal {    

    constructor( private reportService: ReportsService,
                 private facilityService: FacilitiesService){
        super();
    }    

    title: string = "Download Resident Allergies";
    promptText: string = "Download the Resident Allergies report?";

    generateContent(){           
        //     //this triggers the visual cue that works is been done
        this.hideSpinner = false;
        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList,
        };
        this.reportService.reportsGenerateResidentAllergyReport(requestParams)
            .subscribe(
            (result) => {
                this.downloadFile( result, 'ResidentAllergy.xls');
                this.closeModal();
            }
        );
    }
}